import React from 'react';
import { Box, Container, Grid, Link, Paper, Stack, Typography } from '@mui/material';
import ContactForm from '../../Components/ContactForm';
import Seo from '../../Components/Seo';

const Contact = () => {
    return (
        <Container maxWidth="lg" sx={{ py: { xs: 4, md: 6 } }}>
            <Seo
                title="Contact"
                description="Contact Radiology Illustration for educational feedback, collaboration requests, corrections, permissions, and general questions."
                canonicalPath="/contact"
            />
            <Grid container spacing={4} alignItems="flex-start">
                <Grid size={{ xs: 12, md: 5 }}>
                    <Typography
                        variant="h1"
                        sx={{
                            fontSize: { xs: '1.9rem', md: '2.6rem' },
                            fontWeight: 700,
                            mb: 2,
                            lineHeight: 1.2,
                        }}
                    >
                        Contact Radiology Illustration
                    </Typography>
                    <Typography variant="body1" color="text.secondary" sx={{ lineHeight: 1.8, mb: 3 }}>
                        Use this page for educational feedback, collaboration requests, corrections, content permissions, and general questions about the radiology learning resources on this website.
                    </Typography>
                    <Paper variant="outlined" sx={{ p: 2.5, borderRadius: 2 }}>
                        <Typography variant="h2" sx={{ fontSize: '1.2rem', fontWeight: 700, mb: 1 }}>
                            Public Channels
                        </Typography>
                        <Stack spacing={1}>
                            <Link href="https://www.instagram.com/dr.shubham_arora" target="_blank" rel="noopener noreferrer">
                                Instagram
                            </Link>
                            <Link href="https://www.youtube.com/@DrShubhamArora" target="_blank" rel="noopener noreferrer">
                                YouTube
                            </Link>
                            <Link href="https://in.linkedin.com/in/dr-shubham-arora-2821aa150" target="_blank" rel="noopener noreferrer">
                                LinkedIn
                            </Link>
                            <Link href="https://www.researchgate.net/profile/Shubham-Arora-11" target="_blank" rel="noopener noreferrer">
                                ResearchGate
                            </Link>
                        </Stack>
                    </Paper>
                    <Box sx={{ mt: 3 }}>
                        <Typography variant="body2" color="text.secondary" sx={{ lineHeight: 1.7 }}>
                            Please do not submit private health information through this website. The content and responses are for education and general communication only.
                        </Typography>
                    </Box>
                </Grid>
                <Grid size={{ xs: 12, md: 7 }}>
                    <ContactForm />
                </Grid>
            </Grid>
        </Container>
    );
};

export default Contact;
